
/* eslint-disable react/jsx-pascal-case */
import React from 'react'
import isEqual from "lodash/isEqual";
import moment from "moment";
import { Component, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DISPLAY_DATE_FORMAT_3 } from "../../../../../util/constants";
import * as helpers from "../../../../../util/helpers";
import DropdownTreeSelect from "./tree/tree1";

export class MultiSelectAll2 extends Component {
  constructor(props) {
    super(props);
    this.state = { data: props.data, clearFilterFlag: props.clearFilterFlag };
  }

  static getDerivedStateFromProps(props, state) {
    if (!isEqual(props.clearFilterFlag, state.clearFilterFlag)) {
      return {
        clearFilterFlag: props.clearFilterFlag,
      };
    }
    return null;
  }

  shouldComponentUpdate = (nextProps) => {
    if (!isEqual(nextProps.clearFilterFlag, this.state.clearFilterFlag)) {
      return true;
    } else {
      return false;
    }
  };

  render() {
    const { data, ...rest } = this.props;
    return (
      <MultiSelectAll2_
        {...this.props}
        type={this.props.type}
        changeSolutions={this.props.changeSolutions}
        changePlansAndNumbers={this.props.changePlansAndNumbers}
        onPlanChange={this.props.onPlanChange}
        onNumberChange={this.props.onNumberChange}
        inlineSearchPlaceholder={this.props.inlineSearchPlaceholder}
      />
    );
  }
}

const assignObjectPaths = (obj, stack) => {
  Object.keys(obj).forEach((k) => {
    const node = obj[k];
    if (typeof node === "object") {
      node.path = stack ? `${stack}.${k}` : k;
      assignObjectPaths(node, node.path);
    }
  });
};

export const MultiSelectAll2_ = (props) => {
  const [data, setData] = useState([]);

  const { clearFilterFlag } = props;

  const userPlans = useSelector((state) => {
    return state.auth.plans;
  });

  const clearSearchStateForSMS = useSelector((state) => {
    return state.auth.clearSearchStateForSMS;
  });

  const clearSearchStateForCallLogs = useSelector((state) => {
    return state.auth.clearSearchStateForCallLogs;
  });

  let selectors = [userPlans, clearSearchStateForSMS];
  if (props.module === "call-logs") {
    selectors = [userPlans, clearSearchStateForCallLogs];
  }

  const [all, setAll] = useState(false);

  useEffect(() => {
    if (clearFilterFlag !== 0)
      for (var i = 0; i < data.length; i++) {
        data[i].checked = false;
        if (data[i].children && data[i].children.length > 0) {
          data[i].children.map((c, i) => {
            c.checked = false;
          });
        }
      }
    setData(data);
    setAll(false);
  }, [clearFilterFlag]);

  const onChange = (currentNode, selectedNodes) => {
    if (currentNode.value === "selectAll2") {
      setAll(currentNode.checked);
      toggleAll(currentNode, currentNode.checked);
    }

    var changedNumbers = [];
    var changedPlans = [];
    var changedPlansMap = {};

    if (currentNode.value === "selectAll2" && currentNode.checked === true) {
      if (userPlans && userPlans.objects && userPlans.objects.length) {
        userPlans.objects.forEach((plan, index) => {
          changedPlans.push({
            label: plan.plan.plan_name,
            value: plan.plan.id,
          });
        });
      }
    } else if (
      currentNode.value === "selectAll2" &&
      currentNode.checked === false
    ) {
      changedPlans = [];
      changedNumbers = [];
    } else if (currentNode.value === "none" && currentNode.checked === true) {
      let plan = currentNode.model.plan;
      if (!changedPlansMap[plan.id + ""]) {
        changedPlansMap[plan.id + ""] = plan.id;
        changedPlans.push({ label: plan.plan_name, value: plan.id });
      }
    } else {
      selectedNodes.map((node, i) => {
        if (node.value === "selectAll2NonRoot" && node.checked === true) {
          let plan = node.model.plan;
          if (!changedPlansMap[plan.id + ""]) {
            changedPlansMap[plan.id + ""] = plan.id;
            changedPlans.push({ label: plan.plan_name, value: plan.id });
          }
        }

        if (node.type === "plan" && node.checked) {
          if (!changedPlansMap[node.model.plan.id + ""]) {
            changedPlansMap[node.model.plan.id + ""] = node.value;
            changedPlans.push({ label: node.label, value: node.value });
            if (node.model.numbers) {
              node.model.numbers.map((number, k) => {});
            }
          }
        }

        if (node.type === "number") {
          if (userPlans && userPlans.objects && userPlans.objects.length) {
            userPlans.objects.forEach((plan, index) => {
              if (plan.plan.id === node.plan_value) {
                const filteredSelectedNode = plan.numbers.filter((data) =>
                  selectedNodes.some((ele) => ele.value === data.phone)
                );
                if (filteredSelectedNode.length === plan.numbers.length) {
                  if (!checkPlanExists(changedPlans, node)) {
                    changedNumbers.push({
                      label: node.model.phone,
                      value: node.model.phone,
                    });
                  }
                } else {
                  if (!checkPlanExists(changedPlans, node)) {
                    changedNumbers.push({
                      label: node.model.phone,
                      value: node.model.phone,
                    });
                  }
                }
              }
            });
          }
        }
      });
    }

    const changeValues = async () => {
      props.changePlansAndNumbers(changedPlans, changedNumbers);
    };

    setTimeout(() => {
      changeValues();
    }, 4);
  };

  const checkPlanExists = (plans, node) => {
    return plans.some((obj) => obj.value === node.plan_value);
  };

  const prepareData = (data) => {
    return data;
  };

  const toggleAll = (currentNode, checked) => {
    if (currentNode.value === "selectAll2") {
      for (var i = 0; i < data.length; i++) {
        data[i].checked = checked;
        if (data[i].children && data[i].children.length > 0) {
          data[i].children.map((c, i) => {
            c.checked = checked;
          });
        }
      }
      setData([...data]);
    }

    return;
  };

  useEffect(() => {
    var list = [];
    if (userPlans && userPlans.objects) {
      let selectedPlans =
        props.module === "call-logs"
          ? helpers.getSelectedPlansForCallLogs()
          : helpers.getSelectedPlansForSMS();

      let selectedNumbers =
        props.module === "call-logs"
          ? helpers.getSelectedNumbersForCallLogs()
          : helpers.getSelectedNumbersForSMS();
      let activeHeaderAdded = false;
      let inactiveHeaderAdded = false;
      let defaultCheckValue = false;

      const allOption = {
        label: "All Plans",
        value: "selectAll2",
        className: "select-all all-plans",
        children: [],
      };
      allOption.checked = defaultCheckValue;

      if (selectedPlans && selectedPlans.length) {
        selectedPlans.map((v, k) => {
          if (v === "selectAll2") {
            allOption["checked"] = true;
          }
        });
      }
      list.push(allOption);

      userPlans.objects.map((plan, i) => {
        if (plan.is_expired === false) {
          if (!activeHeaderAdded) {
            var trHPlan = {
              label: "Active",
              type: "header",
              model: null,
              value: "h1",
              children: [],
            };
            activeHeaderAdded = true;
          }
        }

        if (plan.is_expired === true) {
          if (!inactiveHeaderAdded) {
            let trHPlan = {
              label: "Inactive",
              type: "header",
              model: null,
              value: "h2",
              children: [],
            };
            inactiveHeaderAdded = true;
          }
        }

        var trPlan = {
          label: plan.plan.plan_name,
          type: "plan",
          model: plan,
          value: plan.plan.id,
          id: "plan-" + plan.plan.id,
          children: [],
          checked: defaultCheckValue,
        };

        var planExists = false;
        if (selectedPlans && selectedPlans.length) {
          selectedPlans.map((v, k) => {
            if (v === "*" || v === plan.plan.id) {
              planExists = true;
              trPlan["checked"] = true;
            }
          });
        }

        if (plan.is_expired === true) {
          trPlan.sub_title = moment(plan.expiry_time).format(
            DISPLAY_DATE_FORMAT_3
          );
        }
        if (plan.is_expired !== true) {
          const allOptionNonRoot = {
            label: "All Numbers",
            value: "selectAll2NonRoot",
            className: "dddselect-all all-numbers",
            model: plan,
            plan: plan.plan,
            children: [],
          };
          allOptionNonRoot.checked = false;

          if (plan.numbers.length > 0) {
            trPlan.children.push(allOptionNonRoot);
          }

          plan.numbers.map((number, j) => {
            var numberObj = {
              label: number.phone,
              type: "number",
              model: number,
              value: number.phone,
              id: "num-" + number.phone,
              plan_label: trPlan.label,
              plan_value: trPlan.value,
              plan: plan.plan,
              checked: defaultCheckValue,
            };

            if (selectedNumbers && selectedNumbers.length) {
              selectedNumbers.map((v, k) => {
                if (v === "*" || v === number.phone) {
                  numberObj["checked"] = true;
                }
              });
            }

            trPlan.children.push(numberObj);
          });
        }
        if (plan.is_expired !== true && plan.numbers.length) {
          list.push(trPlan);
        }
      });
      setData(prepareData(list));
    }
  }, selectors);

  return (
    <span className="msav2">
      <DropdownTreeSelect
        showPartiallySelecteddd={true}
        showDropdown="always"
        viewMode="full-mode"
        keepTreeOnSearch={true}
        keepChildrenOnSearch={true}
        keepOpenOnSelect={false}
        data={data}
        onChange={onChange}
        className="bootstrap-demo"
        texts={{
          inlineSearchPlaceholder: props.inlineSearchPlaceholder
            ? props.inlineSearchPlaceholde
            : "Search",
          noMatches: "No Match Found",
          label: "ex",
          labelRemove: "rm",
          placeholder: "pp",
        }}
      />
    </span>
  );
};
